module.exports = __webpack_public_path__ + "static/media/bgbefore.a399771b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pic/bgbefore.png
// module id = 452
// module chunks = 58